export const CV_COVERAGE_WORKER_SCRIPT_URL = '/cv.worker.js'
export const PREFIX_LOG = `[mockup-generator][cv-coverage]`
